var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import ReactResizeDetector from "react-resize-detector";
import { styled } from "@mui/system";
var StyledCanvas = styled("canvas")({
    position: "absolute",
    left: 0,
    right: 0,
    height: "100%",
    width: "100%",
    pointerEvents: "none",
});
export var Canvas = React.forwardRef(function (_a, ref) {
    var drawCallback = _a.drawCallback, onResize = _a.onResize, props = __rest(_a, ["drawCallback", "onResize"]);
    // State
    var _b = React.useState(0), width = _b[0], setWidth = _b[1];
    var _c = React.useState(0), height = _c[0], setHeight = _c[1];
    // Callbacks
    var onResizeHandler = React.useCallback(function (w, h) {
        setWidth(w);
        setHeight(h);
        onResize === null || onResize === void 0 ? void 0 : onResize(w, h);
    }, [onResize]);
    // Effects
    React.useLayoutEffect(function () {
        if (!drawCallback) {
            return;
        }
        var frameId = requestAnimationFrame(drawCallback);
        return function () { return cancelAnimationFrame(frameId); };
    }, [drawCallback, width, height]);
    return (React.createElement(ReactResizeDetector, { handleHeight: true, handleWidth: true, onResize: onResizeHandler },
        React.createElement(StyledCanvas, __assign({ ref: ref }, props))));
});
export default React.memo(Canvas);
//# sourceMappingURL=Canvas.js.map